export const REQUIRED_APPROVERS = 2;

export const getRequiredApproverCount = (): number => REQUIRED_APPROVERS;

export const hasRequiredApproverCount = (approverCount: number): boolean =>
  approverCount >= REQUIRED_APPROVERS;
